import { FlaskConical, Zap } from 'lucide-react';
import { useEnvironment } from '../../context/EnvironmentContext';
import type { PortalEnvironment } from '../../api/types';

export function EnvironmentSwitcher() {
  const { environment, setEnvironment, isSandbox } = useEnvironment();

  const set = (env: PortalEnvironment) => setEnvironment(env);

  return (
    <div
      className={`inline-flex rounded-xl border p-1 ${
        isSandbox ? 'border-onyx-purple/40 bg-onyx-purple/5' : 'border-onyx-gold/40 bg-onyx-gold/5'
      }`}
    >
      <button
        type="button"
        onClick={() => set('sandbox')}
        className={`flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs font-semibold transition ${
          environment === 'sandbox'
            ? 'bg-onyx-purple text-white shadow-purple'
            : 'text-onyx-muted hover:text-onyx-text'
        }`}
      >
        <FlaskConical size={14} />
        Sandbox
      </button>
      <button
        type="button"
        onClick={() => set('production')}
        className={`flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs font-semibold transition ${
          environment === 'production'
            ? 'bg-onyx-gold text-onyx-bg shadow-gold'
            : 'text-onyx-muted hover:text-onyx-text'
        }`}
      >
        <Zap size={14} />
        Live
      </button>
    </div>
  );
}
